import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import classnames from 'classnames';
import { ISvgIconProps } from '@fluentui/react-icons';
import styles from '../NavigationBar.module.scss';

interface NavItemProps {
    active: boolean;
    icon: React.FC<React.HTMLAttributes<HTMLSpanElement> & ISvgIconProps>;
    to: string;
    label: string;
}

export const NavItem: React.FC<NavItemProps> = ({ active, icon: Icon, to, label }) => {
    const location = useLocation();

    return (
        <Link
            to={{ pathname: to, search: location.search }}
            data-link-to={to}
            data-link-name={label}
            style={{ textDecoration: 'none' }}
        >
            <div className={classnames(styles.navItem, styles.viewButton, { [styles.active]: active })}>
                <Icon className={styles.icon} />

                <span className={styles.label}>{label}</span>
            </div>
        </Link>
    );
};
